import AsyncStorage from "@react-native-async-storage/async-storage";
import i18n from 'i18next';
import { deviceConfig } from "../Redux/Actions/deviceConfigAction";
import { getHotelLang } from "../Redux/Actions/hotelLangAction";
import { getHotelList } from "../Redux/Actions/hotelSelectorAction";
import { getServerDateTime } from "../Redux/Actions/serverDateTimeAction";
import { updateAdditionalTranslationResources } from "../translations";
import { current_client_config, currentIP, getAppConfig, GLOBAL_IV, GLOBAL_SALT } from "../config/Constant";
import { registerDevice } from "../Redux/Actions/registerDeviceAction";
import { resetAppConfig, setCanProceedRenderApp, setClientId, setConnectorIP, setDeviceIdentifier, setInitAppLogout, setIsLoggedIn, setLoggedInRoomNumber, setRenderApp, setServiceStatus, setSessionToken } from "../Redux/Reducers/appConfigReducer";
import { resetDeviceConfig } from "../Redux/Reducers/deviceConfigReducer";
import { resetHotelLang } from "../Redux/Reducers/hotelLangReducer";
import { resetServerDateTime } from "../Redux/Reducers/serverDateTimeReducer";
import { guestJourneyNotification } from "../Redux/Actions/gjNotificationAction";
import { fetchAppConfig } from "../Redux/Actions/getAppConfig";
import { fetchGuestDetails } from "../Redux/Actions/guestDetailsAction";
import { resetGuestDetails, setCurrentGuestDetails, setGuestDetailsList } from "../Redux/Reducers/guestDetailsReducer";
import { getGuestItineraryList } from "../Redux/Actions/guestItineraryAction";
import { checkAppHealthService } from "../Redux/Actions/appHealthService";
import { resetPreCheckInConfig, setBookingStatus, setPreCheckInStatus } from "../Redux/Reducers/checkInReducer";
import { resetGuestItinerary } from "../Redux/Reducers/guestItineraryReducer";
import { resetDynamicStyle } from "../Redux/Reducers/dynamicStyleSheetReducer";
import { AesUtil } from "./AesUtil";
import { resetGuestBillDetails } from "../Redux/Reducers/viewBillReducer";
import {  parseToGlobalDate } from "./utility";
import { Platform } from "react-native";
import { resetAppPreservedConfig, setTempStoreConnectorIP, setTempStoredClientId } from "../Redux/Reducers/appPreservedConfigReducer";

let crashlytics;
if (Platform.OS !== 'web') {
  const moduleName = '@react-native-firebase/crashlytics';
  import(/* webpackIgnore: true */ moduleName)
    .then(module => {
      crashlytics = module.default;
    })
    .catch(() => {});
}


let numOfRegisterCalls = 0;
export const makeLayoutApiCalls = ({avoidDataReset=false, isOnline: isOnlineProp } = {}) => {

    return async (dispatch, getState) => {

        let aesUtil = new AesUtil(128, 1000);
        const { isOnline, serviceStatus } = getState().appConfigSlice;
        let connectionStatus = typeof isOnlineProp === 'boolean' ? isOnlineProp : isOnline;

        let sessionClientID, sessionConnectorIP
        const { clientId, ConnectorIP } = getState().appConfigSlice;
        const { tempStoredclientId, tempStoredConnectorIP } = getState().appPreservedConfigSlice;

        if(serviceStatus.hasError){
            return;
        }
        if(!connectionStatus){
            sessionClientID = tempStoredclientId || clientId;
            sessionConnectorIP = tempStoredConnectorIP || ConnectorIP;
        } else {
            sessionClientID = clientId;
            sessionConnectorIP = ConnectorIP;
        }

        await getAppConfig({ clientId: sessionClientID, ConnectorIP: sessionConnectorIP });


        dispatch(setTempStoreConnectorIP(sessionConnectorIP));
        dispatch(setTempStoredClientId(sessionClientID));

        dispatch(setConnectorIP(currentIP));
        dispatch(setClientId(current_client_config));

        // handle register device config
        let appClientConfig = await AsyncStorage.getItem("current_client_config");
        if(connectionStatus && appClientConfig && (appClientConfig != current_client_config)){
            dispatch(setInitAppLogout(true));
            return;
        }

        if(connectionStatus && !avoidDataReset){
            dispatch(setRenderApp(false));
            dispatch(resetDeviceConfig());
            dispatch(resetServerDateTime());
            dispatch(resetHotelLang());
            dispatch(resetDynamicStyle());
            dispatch(resetGuestItinerary());

            dispatch(resetGuestDetails());
            dispatch(resetAppConfig());
            dispatch(resetAppPreservedConfig());
            dispatch(resetPreCheckInConfig());
            dispatch(resetGuestBillDetails());
        }

        if (numOfRegisterCalls > 10) {
            numOfRegisterCalls = 0;
            return;
        }


        let GuestJourneySessionToken = await AsyncStorage.getItem("sessionToken");
        let GuestJourneyDeviceIdentifier = await AsyncStorage.getItem("DeviceIdentifier");
        let room = await AsyncStorage.getItem("room");

        if (!GuestJourneySessionToken) {
            if(!connectionStatus){
                dispatch(setServiceStatus({ hasError: true, errorMessage: i18n.t('offlineModal.subtitle') }));
                return;
            }
            numOfRegisterCalls++;
            dispatch(registerDevice(() => dispatch(makeLayoutApiCalls())));
            return;
        }

        dispatch(setSessionToken(GuestJourneySessionToken));
        dispatch(setDeviceIdentifier(GuestJourneyDeviceIdentifier));
        if(crashlytics) crashlytics().setUserId(GuestJourneyDeviceIdentifier);

        if(room){

            let guestDetailsList = JSON.parse(await AsyncStorage.getItem("current_guest_list"));
            let currentGuestDetails = JSON.parse(await AsyncStorage.getItem("current_guest_details"));
            dispatch(setGuestDetailsList(guestDetailsList));
            const parsedCurrentGuestDetails = parseToGlobalDate(currentGuestDetails)
            dispatch(setCurrentGuestDetails(parsedCurrentGuestDetails))

            dispatch(setLoggedInRoomNumber(room));
            dispatch(setIsLoggedIn(true));
        }
        
        dispatch(updateAdditionalTranslationResources());

        if(!connectionStatus){
            dispatch(setCanProceedRenderApp(true));
            return;
        }
         
        dispatch(setCanProceedRenderApp(true));

        dispatch(deviceConfig());
        dispatch(triggerRepitativeApiCalls());
        dispatch(callAppHealthService());
        dispatch(getHotelLang());
        dispatch(getHotelList());
        dispatch(guestJourneyNotification());
        dispatch(fetchAppConfig())
        dispatch(fetchGuestDetails());
    }
};

let repitativeApiCall = null;
export const triggerRepitativeApiCalls = () => {

    return async (dispatch, getState) => {

        dispatch(getServerDateTime());

        if (repitativeApiCall) return;

        repitativeApiCall = setInterval(() => {
            dispatch(getServerDateTime());
        }, 180000);
    }
}



let repitativeAppHealthCall = null;
export const callAppHealthService = () => {

    return async (dispatch, getState) => {

        dispatch(checkAppHealthService());

        if (repitativeAppHealthCall) return;

        repitativeAppHealthCall = setInterval(() => {
            dispatch(checkAppHealthService());
        }, 180000);
    }
}